module.exports = __webpack_public_path__ + "img/coming-soon.29db7cf0.svg";